import React, { useEffect, useState } from 'react';
import { AppDispatch, useAppSelector } from '../../../../../../redux/store';
import { useDispatch } from 'react-redux';
import { getCategoriesProductAsync, getAllProductsAsync } from '../../../../../../redux/features/product/services';
import { InputDefault } from '../../../../../data/inputDefault';
import { setPrice } from '../../../../../../redux/features/product/product-slice';
import { ModalProducts } from './ModalProducts';
import { FaSearchPlus } from 'react-icons/fa';
import { IActivedTab } from '../index';

interface IProps {
  activedtab: IActivedTab;
}

export function NavbarIntern({ activedtab }: IProps) {
  const dispatch = useDispatch<AppDispatch>();
  const storeMe = useAppSelector(({ storeMeReducer }) => storeMeReducer.value);
  const { price, product, allProducts } = useAppSelector(
    ({ productReducer }) => productReducer.value
  );
  const [open, setOpen] = useState<boolean>(false);

  
  const handleOpenModal = () => {
  console.log('🖱️ [NavbarIntern] handleOpenModal chamado');
  console.log('🏪 [NavbarIntern] storeId:', storeMe?.storeActive?.id);
  console.log('📋 [NavbarIntern] allProducts atual:', allProducts?.length);
  console.log('🔄 [NavbarIntern] isComplement:', !!activedtab?.comentario);

  if (!allProducts || allProducts.length === 0) {
    console.log('📡 [NavbarIntern] Cache vazio — disparando getAllProductsAsync...');
    dispatch(
      getAllProductsAsync({
        storeId: storeMe?.storeActive?.id ?? 0,
        isComplement: !!activedtab?.comentario,
      })
    );
  } else {
    console.log('⚡ [NavbarIntern] Usando cache — sem requisição');
  }
  setOpen(true);
};


  const handlePrice = (e: string) => {
    const value = parseFloat(e.replace(/\./g, '').replace(',', '.'));
    dispatch(setPrice(Number(value)));
  };

  const formatCurrency = (value: any) => {
    if (!value) return '0,00';
    const cleanedValue = value.toString().replace(/\D/g, '');
    const number = parseFloat(cleanedValue) / 100;
    return number.toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const handleClose = () => setOpen(false);

  useEffect(() => {
    dispatch(getCategoriesProductAsync(storeMe?.storeActive?.id));
  }, [dispatch]);

  return (
    <>
      <ModalProducts
        show={open}
        handleClose={handleClose}
        dispatch={dispatch}
        storeId={storeMe?.storeActive?.id}
        activedtab={activedtab}
      />
      <div className="navIntern">
        <div className="contentInput">
          <div className="wrapperProduct">
            <span className="mt-1"> Produto</span>
            <div className="saleName">
              <InputDefault
                placeholder="name"
                type="text"
                state={product?.sale_name ?? ''}
                disabled
              />
            </div>
            <InputDefault
              placeholder="codigo"
              type="text"
              state={product?.id_pdv ?? ''}
              disabled
            />
            <FaSearchPlus
              onClick={handleOpenModal}
              size={16}
              color="gray"
              style={{ marginTop: '5px', marginLeft: '3px', cursor: 'pointer' }}
            />
          </div>

          <div className="contentInput">
            <div className="wrapperProduct">
              <span className="mt-1"> Preço</span>
              <InputDefault
                placeholder="0,00"
                type="number"
                state={price}
                onChenge={(e: any) =>
                  dispatch(setPrice(e.target.value ?? '0,00'))
                }
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}